import axios from 'axios';
import _ from 'lodash';
import { handlePostWithResult } from '../../../../utils/AxiosUtil';
import {  trimSpaces } from '../../../../utils/Util';

export const fields = [
    'publicId', 'billDate', 'fullFillmentDate', 'paymentDeadline', 'amount', 'vat', 'comment'
]
//customer
export const promiseCustomerOptions = async (inputValue) => {
    const response = await axios.get('/api/outgoingbill/customers')
    const renamedCustomers = [];
    response.data.map((customer) =>
        renamedCustomers.push({
            label: customer.name,
            value: customer.privateId,
        }));
    return renamedCustomers;
};

export const handleCustomerSelected = (e, v, this2) => {
    console.log(v);
    console.log(this2.state.selectedCustomer);
    var b = false;
    if (v === null) {
        b = true;
        this2.setState({ selectedProject: null })
    }
    if (v && v.inputValue) {
        //new customer
        const path = '/api/outgoingbill/customer';
        const requestObject = { "name": v.inputValue };
        handlePostWithResult(path, requestObject, (res) => handleSuccessNewCustomer(v, res.privateId, this2), this2);
    } else {
        this2.setState({ selectedCustomer: v, customerRelatedDropDown: b })
    }
    if (v && v.value!==this2.state.selectedCustomer.value){
        this2.setState({selectedProject: null})
    }
}

const handleSuccessNewCustomer = (v, id, this2) => {
    let newCustomer = {
        label: v.inputValue,
        value: id,
    }
    this2.setState({ selectedCustomer: newCustomer, customerRelatedDropDown: false })
    v.label = v.inputValue;
}

//project
export const promiseProjectOptions = async (customer) => {
    console.log(customer)
    const response = await axios.post('/api/outgoingbill/projects', { "customerId": customer.value })
    const renamedProjects = [];
    response.data.map((project) =>
        renamedProjects.push({
            label: project.publicId + '-' + project.location,
            value: project.privateId,
        }));
    return renamedProjects;
};

export const handleProjectSelected = (e, v, this2) => {
    if (v && v.inputValue) {
        //new customer
        const path = '/api/outgoingbill/project';
        let newProject = _.split(v.inputValue, '-', 2);
        const requestObject = {
            publicId: Number(newProject[0]),
            location: newProject[1],
            customerId: this2.state.selectedCustomer.value
        }
        handlePostWithResult(path, requestObject, (res) => handleSuccessNewProject(v, res.privateId, this2), this2);
    } else {
        this2.setState({selectedProject: v})
    }
}

const handleSuccessNewProject = (v, id, this2) => {
    let newProject = {
        label: v.inputValue,
        value: id,
    }
    this2.setState({selectedProject: newProject});
    v.label = v.inputValue;
}

export const isValidNewWork = (inputValue) => {
    let newOption = _.split(inputValue, '-', 2);
    if (newOption.length === 2 && newOption[0].length > 0 && newOption[1].length > 0) {
        let number = Number(newOption[0]);
        if (_.isFinite(number)) {
            return true;
        }
        return false;
    }
    return false;
}

export const filterForProject = (options, params) => {
    let filtered = options.filter(option => {
        let o = _.split(option.label, '-', 2);
        let n = _.split(params.inputValue, '-', 2)
        return o[0].includes(n[0]);

    })
    return filtered;
}

//export const handleChange = (event, this2) => {
//    this2.setState({ [event.target.name]: event.target.value });
//    removeErrorMessage(event.target.name, this2);
//}

const removeErrorMessage = (name, this2) => {
    if (this2.state.errors.has(name)) {
        let copy = this2.state.errors;
        copy.delete(name);
        this2.setState({ errors: copy });
    }
}

export const handleBillDateChange = (value, this2) => {
    this2.setState({ billDate: value });
    if (this2.state.selectedPaymentMethod.value === "CASH") {
        this2.setState({ fulfillmentDate: value, paymentDeadline: value, equalizationDate: value });
    }
    removeErrorMessage("billDate", this2);
}

export const handleFulfillmentDateChange = (value, this2) => {
    this2.setState({ fulfillmentDate: value });
    if (this2.state.selectedPaymentMethod.value === "CASH") {
        this2.setState({ billDate: value, paymentDeadline: value, equalizationDate: value });
    }
    removeErrorMessage("fullFillmentDate", this2);
}

export const handlePaymentDeadlineChange = (value, this2) => {
    this2.setState({ paymentDeadline: value });
    if (this2.state.selectedPaymentMethod.value === "CASH") {
        this2.setState({ billDate: value, fulfillmentDate: value, equalizationDate: value });
    }
    removeErrorMessage("paymentDeadline", this2);
}

export const handleAmountChange = (event, this2) => {
    if (event.target && event.target.name) {
        const vat = getVat(event.target.value);
        this2.setState({ [event.target.name]: event.target.value, vat: vat })
        if (this2.state.errors) {
            if (this2.state.errors.has(event.target.name)) {
                let copy = this2.state.errors;
                copy.delete(event.target.name);
                this2.setState({ errors: copy });
            }
        } else {
            console.error("no errors");
        }
    } else {
        console.error("no event.target or event.target.name");
    }
}

const getVat = (value) => {
    if (!isNaN(trimSpaces(value))) {
        return Math.round(trimSpaces(value) * 0.2125984);
    } else {
        return value;
    }
}

